/**
 * Created by CCristi <ccovali@mitocgroup.com> on 4/21/16.
 */

'use strict';

/**
 * Resolves lambda response
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let Resolver = exports.Resolver = function () {
  /**
   * @param {Function} lambdaCallback
   */
  function Resolver(lambdaCallback) {
    _classCallCheck(this, Resolver);

    this._lambdaCallback = lambdaCallback;
    this._onSucceed = [];
  }

  /**
   * @param {Object} object
   */


  _createClass(Resolver, [{
    key: 'succeed',
    value: function succeed(object) {
      this._onSucceed.forEach(cb => cb(object));

      this._lambdaCallback(null, object);
    }

    /**
     * @param {Object} object
     */

  }, {
    key: 'fail',
    value: function fail(object) {
      this._lambdaCallback(object, null);
    }

    /**
     * @param {Function} cb;
     */

  }, {
    key: 'registerSucceedCallback',
    value: function registerSucceedCallback(cb) {
      this._onSucceed.push(cb);
    }
  }]);

  return Resolver;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/Lambda/Resolver.js
// module id = 366
// module chunks = 0